/*
 * Copyright (c) 2026, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you've
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    valuePropsRoot: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.spacing(8),
      // Wraps rather than switching at a breakpoint: the two columns stop
      // fitting when the copy in them stops fitting, which depends on the
      // translation as much as on the window.
      flexWrap: 'wrap',
    },
    artworkWrap: {
      // Grows and shrinks with the row, but gives up before the copy does:
      // a squeezed diagram is unreadable well before squeezed text is.
      flex: '1 1 380px',
      maxWidth: theme.spacing(80),
      minWidth: 0,
    },
    artwork: {
      display: 'block',
      width: '100%',
      height: 'auto',
    },
    propsList: {
      flex: '1 1 360px',
      minWidth: 0,
      // A plain <ul>, so the points are announced as the list they are.
      margin: 0,
      padding: 0,
      listStyle: 'none',
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(3),
    },
    propItem: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: theme.spacing(2),
    },
    propIcon: {
      fontSize: theme.spacing(3),
      // Muted rather than brand-coloured, per the design: the icons label the
      // points, they are not the thing being read.
      color: theme.palette.text.secondary,
      flexShrink: 0,
      // Sits against the cap height of the title rather than the top of its
      // line box, which is a couple of pixels higher.
      marginTop: theme.spacing(0.5),
    },
    propTitle: {
      fontWeight: 500,
    },
  })
);
